import { getThemeColor } from '../../theme/_';

const shadowColor = getThemeColor('blue.100');
export const cardDefaults: { bgColor: string, boxShadow: string, rounded: number } = {
  bgColor: 'white',
  boxShadow: `0px 0px 15px ${shadowColor}`,
  rounded: 5,
};